import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import {
  CabinCache,
  CabinCacheList,
} from '@app/complex-flight-availability/presenter/complex-flight-availability-pres.state';
import { FlightType } from '@common/components';
import { MASTER_TABLE } from '@conf/asw-master.config';
import { SupportComponent } from '@lib/components/support-class';
import { AswMasterService, CommonLibService } from '@lib/services';
import { ComplexRequest } from 'src/sdk-search';

@Component({
  selector: 'asw-cabin-class',
  templateUrl: './cabin-class.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CabinClassComponent extends SupportComponent {
  /** キャビンクラス切り替えボタン押下 */
  @Output()
  public clickCabinClassEvent = new EventEmitter<Event>();

  public _complexRequest?: ComplexRequest;
  @Input()
  set complexRequest(data: ComplexRequest | undefined) {
    this._complexRequest = data;
    if (this._flightType && this._complexRequest?.fare.cabinClass) {
      this.setCabinClass(this._flightType, this._complexRequest?.fare.cabinClass);
    }
  }
  get complexRequest(): ComplexRequest | undefined {
    return this._complexRequest;
  }

  public _flightType?: FlightType;
  @Input()
  set flightType(data: FlightType | undefined) {
    this._flightType = data;

    if (this._flightType && this._complexRequest?.fare.cabinClass) {
      this.setCabinClass(this._flightType, this._complexRequest?.fare.cabinClass);
    }
  }
  get flightType(): FlightType | undefined {
    return this._flightType;
  }

  /** コンストラクタ */
  constructor(
    protected common: CommonLibService,
    private _changeDetectorRef: ChangeDetectorRef,
    private _aswMasterSvc: AswMasterService
  ) {
    super(common);
  }

  public cabin: string = '';

  public cabinStr: string = '';

  /** 初期表示処理 */
  init() {}

  /** 画面終了時処理 */
  destroy() {}

  /** 画面更新時処理 */
  reload() {}

  /** CabinClassの設定処理 */
  private async setCabinClass(flightType: FlightType, cabinClass: string) {
    let label = '';
    const cabinCacheList: CabinCacheList = await this._aswMasterSvc.aswMaster[MASTER_TABLE.M_LIST_DATA_930.key];
    cabinCacheList &&
      cabinCacheList[flightType].length &&
      cabinCacheList[flightType].forEach((cabin: CabinCache) => {
        if (cabinClass === cabin.value) {
          label = cabin.label;
        }
      });
    this.cabin = label;
    this._changeDetectorRef.markForCheck();
  }

  /**
   * キャビンクラス切替ボタン押下
   */
  public cabinClass(event: Event) {
    this.clickCabinClassEvent.emit(event);
  }
}
